import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=164f70bd&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=164f70bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f70bd",
  null
  
)

export default component.exports